import { Box, Button, Center, VStack } from "native-base";
import React from "react";
import styled from "styled-components/native";

import EmptyList from "@/components/molecules/EmptyList";
import ProductCard from "@/components/molecules/ProductCard";
import ProductCardLoading from "@/components/molecules/ProductCard/ProductCardLoading";

import { ProductListProps } from "./types";

const ProductListWeb = ({
  data,
  isLoading,
  isLoadingMore,
  onLoadMore,
  onSelect,
  onPressDecrease,
  onPressIncrease,
}: ProductListProps) => {
  return (
    <>
      {data.length === 0 ? (
        <EmptyList />
      ) : (
        <VStack>
          <List>
            {data?.map((product, index) =>
              isLoading ? (
                <ProductCardLoading key={index} />
              ) : (
                <ProductCard
                  key={product.item._id}
                  item={product}
                  onPressDecrease={() => onPressDecrease(product)}
                  onPressIncrease={() => onPressIncrease(product)}
                  onSelect={() => onSelect(product.item?._id)}
                />
              )
            )}
          </List>
          <Center w="full">
            <Button
              w="1/2"
              variant="outline"
              borderColor="primary.600"
              my="8"
              isLoading={isLoadingMore}
              onPress={onLoadMore}>
              Ver mais
            </Button>
          </Center>
        </VStack>
      )}
    </>
  );
};

const List = styled(Box)`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 1rem;
`;

export default ProductListWeb;
